import { getData, postData, putData, deleteData } from "../apiClient";

// get users with pagination
export const getRoomSizesWithPagination = async ({ page = 1, limit = 10, search = "" }, signal = null) => {
  try {
    const queryParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      search: search,
    });

    const result = await getData(`/room-size/?${queryParams}`, {}, {}, signal);
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error("Get Room Sizes with pagination API error:", error);
    return {
      success: false,
      ...error,
    };
  }
};

// get user data with id
export const getRoomSizeDataWithId = async (id) => {
  try {
    const result = await getData(`/room-size/${id}`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error("Get Room Size data API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

// create user ** // Updated Api Error Handle Method
export const createRoomSize = async ({ data }) => {
  try {
    const result = await postData(`/room-size/`, data);
    
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error("Room Size API error:", error.status === 400 ? error.error : error.message);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};

// delete user
export const deleteRoomSize = async ({ id }) => {
  try {
    const result = await deleteData(`/room-size/${id}`);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error("Room Size API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

// update user data
export const updateRoomSize = async ({id, data }) => {
  try {
    const result = await putData(`/room-size/${id}`, data);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error("Room Size API error:", error);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};
